import { cnl } from "./value";

export type C8AttributeId = string;
export type C8NodeType = string;

export const NODE_TYPE = {
	BUILD_IN_ATTRIBUTE: "BuildInAttribute",
	CUSTOM_ATTRIBUTE: "CustomAttribute",
};

export const ATTR_NAME = "Node Name";
export const ATTR_PARENT = "__Parent__";
export const ATTR_TYPE = "Node Type";
export const ATTR_SUBTYPE = "Subtype";

export type C8NodeRight = {
	Admin: number;
	Read: number;
	Write: number;
};

interface C8NodeKnownProperties {
	$Name: string;
	$Type: string;
	$URL: cnl;
	[ATTR_PARENT]: string;
	[ATTR_SUBTYPE]?: string;
	[ATTR_NAME]: string;
	[ATTR_TYPE]: C8NodeType;

	$attrs?: object;
	$CR?: cnl;
	$CT?: number;
	$FG?: number;
	$PB?: cnl;
	$PT?: number;
	$Right?: C8NodeRight;
}

interface C8NodeUnknownAttributes {
	// any other properties are allowed
	//TODO: use C8AttributeValue instead of 'any'.
	// It will force to use Type Assertions for unknown attributes
	// See https://www.typescriptlang.org/docs/handbook/2/everyday-types.html#type-assertions
	[propName: string]: any; //C8AttributeValue;
}

/** C8 node type */
export type C8Node = C8NodeKnownProperties & C8NodeUnknownAttributes;

/** C8 node or cnl */
export type C8NodeOrCnl = cnl | C8Node;

/** empty url */
export const DUMMY: cnl = "centric:";

/** return cnl for node given the node or its cnl */
export function getNodeCnl(cnlOrNode: C8NodeOrCnl): cnl | undefined {
	const node = cnlOrNode as C8Node;
	const url = cnlOrNode as cnl;
	return node?.$URL || url;
}
